import type { TypeIcon } from 'constants/types';
import { ReactComponent as BugSVG } from 'assets/svg/bug.svg';
import { ReactComponent as DarkSVG } from 'assets/svg/dark.svg';
import { ReactComponent as DragonSVG } from 'assets/svg/dragon.svg';
import { ReactComponent as ElectricSVG } from 'assets/svg/electric.svg';
import { ReactComponent as FairySVG } from 'assets/svg/fairy.svg';
import { ReactComponent as FightingSVG } from 'assets/svg/fighting.svg';
import { ReactComponent as FireSVG } from 'assets/svg/fire.svg';
import { ReactComponent as FlyingSVG } from 'assets/svg/flying.svg';
import { ReactComponent as GhostSVG } from 'assets/svg/ghost.svg';
import { ReactComponent as GrassSVG } from 'assets/svg/grass.svg';
import { ReactComponent as GroundSVG } from 'assets/svg/ground.svg';
import { ReactComponent as IceSVG } from 'assets/svg/ice.svg';
import { ReactComponent as NormalSVG } from 'assets/svg/normal.svg';
import { ReactComponent as PoisonSVG } from 'assets/svg/poison.svg';
import { ReactComponent as PsychicSVG } from 'assets/svg/psychic.svg';
import { ReactComponent as RockSVG } from 'assets/svg/rock.svg';
import { ReactComponent as SteelSVG } from 'assets/svg/steel.svg';
import { ReactComponent as WaterSVG } from 'assets/svg/water.svg';

export const TYPE_ICON: TypeIcon = {
  'BUG': <BugSVG />,
  'DARK': <DarkSVG />,
  'DRAGON': <DragonSVG />,
  'ELECTRIC': <ElectricSVG />,
  'FAIRY': <FairySVG />,
  'FIGHTING': <FightingSVG />,
  'FIRE': <FireSVG />,
  'FLYING': <FlyingSVG />,
  'GHOST': <GhostSVG />,
  'GRASS': <GrassSVG />,
  'GROUND': <GroundSVG />,
  'ICE': <IceSVG />,
  'NORMAL': <NormalSVG />,
  'POISON': <PoisonSVG />,
  'PSYCHIC': <PsychicSVG />,
  'ROCK': <RockSVG />,
  'STEEL': <SteelSVG />,
  'WATER': <WaterSVG />,
};

export default TYPE_ICON;
